/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integration: NonNullable<unknown> }} Audit_Details_Self_Approval_Allowed_DescInputs */



/**
* | output |
* | --- |
* | "Members were allowed to auto-approve the {integration} integration's write tools for the organisation." |
*
* @param {Audit_Details_Self_Approval_Allowed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_self_approval_allowed_desc = /** @type {((inputs: Audit_Details_Self_Approval_Allowed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Self_Approval_Allowed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mitglieder dürfen die Schreib-Werkzeuge der Integration ${i?.integration} jetzt selbst automatisch freigeben.`)
	return /** @type {LocalizedString} */ (`Members were allowed to auto-approve the ${i?.integration} integration's write tools for the organisation.`)
});